// extracted by mini-css-extract-plugin
export default {"balanceValue":"WheelPrize_balanceValue__PBaxb"};